import { observer } from "mobx-react";
import { AreaChart } from "randmarcomps";
import * as React from "react";
import { SalesStatistics } from "../../stores/reseller/Reseller";
import { groupSalesDataByMonth } from "../../utils/statisticsUtils";

interface IProps {
  sales: SalesStatistics[];
}

const SalesHistoryChart: React.FC<IProps> = ({ sales }) => {
  return (
    <AreaChart
      data={groupSalesDataByMonth(sales, 12)}
      series={[
        { name: "Units Sold", label: "Units Sold", color: "hsl(var(--primary))", units: " units", yAxisId: "left", format: "integer" },
      ]}
    />
  );
};

export default observer(SalesHistoryChart);
